export type ShiftProgramFrequency = 'DAILY' | 'WEEKLY' | 'EVERY SHIFT' | 'CUSTOM'

export type ShiftProgramStatus = 'active' | 'paused'

export const SHIFT_PROGRAM_STATUS_COLORS: Record<ShiftProgramStatus, string> = {
  active: '#24D07B',
  paused: '#8A8A8A',
}

export const SHIFT_PROGRAM_STATUS_LABELS: Record<ShiftProgramStatus, string> = {
  active: 'ACTIVE',
  paused: 'PAUSED',
}

export interface IShiftProgramRow {
  id: number
  title: string
  meta: string
  frequency: ShiftProgramFrequency
  lastRun: string
  status: ShiftProgramStatus
}
